var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ds-control ds-subtable-cell-content ds-no-padding"},[_vm._t(_vm.slots[0].name)],2)}
var staticRenderFns = []

export { render, staticRenderFns }